import { cn } from '@/lib/utils'
import {
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices
} from '@/types'
import { Base, Richtext } from '@/ui/components'
import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data:
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityEventList
}

const SpotSanityDetailHead = ({ data, ...props }: Props) => {
  const item = data?.content?.item

  const leadText = item?.leadText || item?.summary

  return (
    <Base {...props} className={'py-none'}>
      {leadText && (
        <h2
          className={cn('h5', 'mb-lg')}
          dangerouslySetInnerHTML={{ __html: leadText }}
        />
      )}
      {item?.description && <Richtext text={item?.description} />}
    </Base>
  )
}

export default memo(SpotSanityDetailHead)
